module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;